// extracted by mini-css-extract-plugin
export default {"header":"header_header__9O5m9","headerbox":"header_headerbox__wSm9s","icon":"header_icon__IKgBf"};